/*
 * This unpublished material is proprietary to Vaticle.
 * All rights reserved. The methods and
 * techniques described herein are considered trade secrets
 * and/or confidential. Reproduction or distribution, in whole
 * or in part, is forbidden except by express written permission
 * of Vaticle.
 */

import { Component, EventEmitter, Inject, Output } from "@angular/core";
import { AsyncPipe } from "@angular/common";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Subject } from "rxjs";
import { FormActionsComponent, ModalComponent, SpinnerComponent } from "typedb-cloud-framework";
import { Cluster, ClusterPrice } from "../../../concept/cluster";
import { ClusterApi } from "../../../service/cluster/cluster-api.service";
import { ApplicationState } from "../../../service/application-state.service";
import { renderThousandthCentsAsUSD } from "../../../util";

export type CloneClusterModalData = { cluster: Cluster };

@Component({
    selector: "tp-clone-cluster-modal",
    templateUrl: "./clone-cluster-modal.component.html",
    styleUrls: ["./clone-cluster-modal.component.scss"],
    imports: [ModalComponent, FormActionsComponent, AsyncPipe, SpinnerComponent]
})
export class CloneClusterModalComponent {
    @Output() confirmed = new EventEmitter<void>();
    isSubmitting$ = new Subject<boolean>();
    price$ = this.clusterApi.getClusterPriceThousandthCentsPerHour(
        { cluster: {  ...this.data.cluster, isFree: false }, teamUuid: this.app.requireCurrentTeam().uuid }
    );

    constructor(
        private dialogRef: MatDialogRef<CloneClusterModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: CloneClusterModalData,
        private clusterApi: ClusterApi, private app: ApplicationState
    ) {}

    confirm(): void {
        this.isSubmitting$.next(true);
        this.confirmed.emit();
    }

    close(): void {
        this.dialogRef.close();
    }

    runningPriceString(price: ClusterPrice) {
        return `${renderThousandthCentsAsUSD(price.running.thousandthCentsPerHour)}/hour`;
    }
}
